import { FC, useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { RootState } from "../../store";
import { connect, ConnectedProps } from "react-redux";
import { ChartData, ChartZoom } from "../../store/chart/types";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const mapState = (state: RootState) => ({
  chartZoom: state.chart.chartZoom,
  data: state.chart.data,
  dayData: state.chart.dayData
});

const mapDispatch = {
  setData: () => ({ data: {} as ChartData }),
  setDayData: () => ({ dayData: {} as ChartData }),
  setChartZoom: () => ({ chartZoom: {} as ChartZoom }),
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & { data: ChartData, dayData: ChartData, chartZoom: ChartZoom };

const DailyBar: FC<Props> = (props: Props) => {
  let displayedData: number[] = [];
  let displayedLabels: string[] = [];
  if (props.chartZoom.dailyBar === "day") {
    displayedData = props.dayData.dayPnl;
    displayedLabels = props.dayData.dayDates;
  } else if (props.chartZoom.dailyBar === "week") {
    displayedData = props.data.weekPnl;
    displayedLabels = props.data.weekDates;
  } else if (props.chartZoom.dailyBar === "month") {
    displayedData = props.data.monthPnl;
    displayedLabels = props.data.monthDates;
  }

  const getColor = () => {
    if (displayedData) {
      const values = displayedData;
      const colors = values.map((value) => {
        if (value > 0) {
          return "rgba(0, 236, 0, 1)";
        } else {
          return "rgba(236, 0, 0, 1)";
        }
      });
      return colors;
    }
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top" as const,
        labels: { color: "#FFFFFF" },
        display: false,
      },
      title: {
        display: false,
        text: "Daily P&L",
        color: "#FFFFFF",
        position: "top",
        align: "start",
        padding: 10,
        font: {
          family: "'Poppins', sans-serif",
          size: 15,
          weight: "400",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#FFFFFF",
          font: {
            family: "'Roboto', sans-serif",
            size: 8,
          },
        },
        grid: {
          color: "rgb(255, 255, 255, 0)",
        },
      },
      y: {
        ticks: {
          color: "#FFFFFF",
          font: {
            family: "'Roboto', sans-serif",
            size: 8,
          },
        },
        grid: {
          color: "rgb(255, 255, 255, 0.1)",
        },
      },
    },
  };

  const labels = displayedLabels;

  const data = {
    labels,
    datasets: [
      {
        label: "P&L",
        data: displayedData,
        backgroundColor: getColor(),
      },
    ],
  };

  useEffect(() => {}, [props]);

  return (
    <div className="w-full h-full">
      {/* @ts-ignore */}
      <Bar options={options} data={data} />
    </div>
  );
};

export default connector(DailyBar);
